import Styles from './styles.module.css';
import '../home/tokens.css';
import Navigation from '../home/1.navigation/index';
import Footer from '../home/10.footer/index';
import { useRef } from 'react';
import DocumentMeta from 'react-document-meta';

const CompanyAbout = () => {

  const problemRef = useRef(null);
  const serviceRef = useRef(null);
  const pointRef = useRef(null);
  const priceRef = useRef(null);
  const functionsRef = useRef(null);

  const scrollTo = (ref: any) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const meta = {
    title: "会社概要 | 株式会社memorii（memorii works）",
    description: "株式会社memoriiの会社概要ページ。美容学生向け求人サイト『memorii works』を運営し、美容室の新卒採用支援と学生の就職活動をサポートしています。",
    canonical: "https://memorii-works.com/about",
    meta: { charset: "utf-8" }
  };
  
  return (
    <>
    <DocumentMeta {...meta}>
      <Navigation 
        onScrollToProblem={() => scrollTo(problemRef)}
        onScrollToService={() => scrollTo(serviceRef)}
        onScrollToPoint={() => scrollTo(pointRef)}
        onScrollToFunctions={() => scrollTo(functionsRef)}
      />
      <div className={Styles.back}>
        <div className={Styles.head}>
          <span className={Styles.kicker}>COMPANY</span>
          <h1 className={Styles.title}>会社概要</h1>
        </div>
        <div className={Styles.contents}>
          <div className={Styles.contents_items}>
            <div>
              <h4>商</h4>
              <h4>号</h4>
            </div>
            <p>株式会社memorii</p>
          </div>
          <div className={Styles.contents_hr}>
            <div className={Styles.contents_hr_left}></div>
            <div className={Styles.contents_hr_right}></div>
          </div>
          <div className={Styles.contents_items}>
            <div>
              <h4>代</h4>
              <h4>表</h4>
              <h4>者</h4>
            </div>
            <p>大林 亜治英</p>
          </div>
          <div className={Styles.contents_hr}>
            <div className={Styles.contents_hr_left}></div>
            <div className={Styles.contents_hr_right}></div>
          </div>
          <div className={Styles.contents_items}>
            <div>
              <h4>会</h4>
              <h4>社</h4>
              <h4>設</h4>
              <h4>立</h4>
              <h4>日</h4>
            </div>
            <p>2019年5月15日</p>
          </div>
          <div className={Styles.contents_hr}>
            <div className={Styles.contents_hr_left}></div>
            <div className={Styles.contents_hr_right}></div>
          </div>
          <div className={Styles.contents_items}>
            <div>
              <h4>U</h4>
              <h4>R</h4>
              <h4>L</h4>
            </div>
            <p>https://memorii-works.com/</p>
          </div>
          <div className={Styles.contents_hr}>
            <div className={Styles.contents_hr_left}></div>
            <div className={Styles.contents_hr_right}></div>
          </div>
          <div className={Styles.contents_items}>
            <div>
              <h4>営</h4>
              <h4>業</h4>
              <h4>時</h4>
              <h4>間</h4>
            </div>
            <p>10:00~19:00</p>
          </div>
          <div className={Styles.contents_hr}>
            <div className={Styles.contents_hr_left}></div>
            <div className={Styles.contents_hr_right}></div>
          </div>
          <div className={Styles.contents_items}>
            <div>
              <h4>住</h4>
              <h4>所</h4>
            </div>
            <p>神奈川県横浜市西区浅間町1丁目4番3号ウィザードビル402</p>
          </div>
          <div className={Styles.contents_hr}>
            <div className={Styles.contents_hr_left}></div>
            <div className={Styles.contents_hr_right}></div>
          </div>
          <div className={Styles.contents_items}>
            <div>
              <h4>取</h4>
              <h4>引</h4>
              <h4>銀</h4>
              <h4>行</h4>
            </div>
            <p>三菱UFJ銀行</p>
          </div>
          <div className={Styles.contents_hr}>
            <div className={Styles.contents_hr_left}></div>
            <div className={Styles.contents_hr_right}></div>
          </div>
          <div className={Styles.contents_items}>
            <div>
              <h4>事</h4>
              <h4>業</h4>
              <h4>目</h4>
              <h4>的</h4>
            </div>
            <ol>
              <li>インターネット等の通信ネットワーク及び電子技術を利用した各種情報提供サービス並びに情報収集サービス</li>
              <li>コンピュータのソフトウェア及びハードウェアの企画、研究、開発、設計、製造、販売、保守並びにこれらに関するコンサルティング業務</li>
              <li>マーケティング・リサーチ及び経営情報の調査、収集及び提供</li>
              <li>在庫管理・発送業務</li>
              <li>展覧会・イベント等の企画・運営業務</li>
              <li>美容業界に特化した求人情報の提供及び採用支援サービスの企画、開発、運営</li>
              <li>資金調達、補助金申請、助成金申請等に関するコンサルティング業務</li>
              <li>前各号に附帯関連する一切の事業</li>
            </ol>
          </div>
          <div className={Styles.contents_hr}>
            <div className={Styles.contents_hr_left}></div>
            <div className={Styles.contents_hr_right}></div>
          </div>
          <div className={Styles.contents_items}>
            <div>
              <h4>お</h4>
              <h4>問</h4>
              <h4>い</h4>
              <h4>合</h4>
              <h4>わ</h4>
              <h4>せ</h4>
            </div>
            <a href="https://memorii-works.com/contact">
              <button>お問い合わせ</button>
            </a>
          </div>
          <div className={Styles.contents_hr}>
            <div className={Styles.contents_hr_left}></div>
            <div className={Styles.contents_hr_right}></div>
          </div>
          <div className={Styles.contents_items}>
            <div>
              <h4>企</h4>
              <h4>業</h4>
              <h4>沿</h4>
              <h4>革</h4>
            </div>
            <p>
              2019年　会社設立<br />
              2019年　WEB、アプリ開発事業の提供開始<br />
              2020年　美容師様向け顧客管理アプリ「memorii」をリリース<br />
              2021年　中小企業向け資金調達事業の提供開始<br />
              2021年　美容学生向け作品撮り共有アプリ「memorii photo」をリリース<br />
              2023年　美容室の新卒採用サービス「memorii works」をリリース<br />
              2024年　横浜市ビジネスグランプリファイナルへ進出<br />
              2025年　株式会社memoriiへ変更
            </p>
          </div>
          <div className={Styles.contents_hr}>
            <div className={Styles.contents_hr_left}></div>
            <div className={Styles.contents_hr_right}></div>
          </div>
        </div>
      </div>
      <Footer />
    </DocumentMeta>
    </>
  );
}


export default CompanyAbout;